<template>
    <tr>
        <td>
            {{item.acao}}
        </td>

        <td>
            {{item.nomeAparelho == null ? 'TODOS' : item.nomeAparelho}}
        </td>

        <td>
            {{item.descricao}}
        </td>

        <td>
            {{item.mac}}
        </td>

         <td>

            <v-icon size="20" slot="activator" v-tooltip="'Remover'" @click="remove">mdi-delete</v-icon>
         </td>


        <app-confirmation-modal :value="!!pendingRemoveId"
                confirm-label="Remover"
                @confirm="confirmRemove"
                @cancel="pendingRemoveId = null">
            <span slot="heading">
                Remover conexão
            </span>

            <span>
                Você tem certeza que deseja remover?
            </span>
        </app-confirmation-modal>

    </tr>
</template>

<script>
    import userTableItem from '@views/admin/mixins/user-table-item'
    import AppConfirmationModal from '@components/ConfirmationModal'
    import EventBus from '@packages/event-bus'
    export default {
        components: {
            AppConfirmationModal
        },

        data() {
            return {
                pendingRemoveId: null,
                entity: 'freeconnections'
            }
        },
        methods: {
            async confirmRemove() {
                await this.$api.freeconnections.remove(this.pendingRemoveId)
                this.pendingRemoveId = null;
                EventBus.$emit(`LOAD_FREECONNECTIONS`)
            },
            remove() {
                this.pendingRemoveId = this.item.id;
            },
        },

        mixins: [userTableItem]
    }
</script>

<style lang="scss" scoped>
    @import "~@variables";

    .edit {

        .mdi {
            font-size: 18px;

            &:not(:last-child) {
                margin-right: 6px;
            }
        }
    }
</style>
